import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import type { DestinationContext } from "@/lib/dashboard-home/destinations";
import { pickerActionGroups } from "@/lib/dashboard-home/shortcut-picker";
import type { StoredShortcut } from "@/lib/dashboard-home/shortcuts";
import { useState } from "react";
import { HomeSearchInput } from "../../HomeSearchInput";
import { PickerRow } from "./PickerRow";

/** Onglet « Actions » : catalogue classé par rubrique, avec recherche. */
export const ActionsTab = ({
  shortcuts,
  context,
  full,
  onAdd,
}: {
  shortcuts: StoredShortcut[];
  context: DestinationContext;
  full: boolean;
  onAdd: (shortcut: StoredShortcut) => void;
}) => {
  const vt = useVisibleT();
  const [query, setQuery] = useState("");
  const groups = pickerActionGroups(shortcuts, context, query, vt);

  return (
    <div className="flex flex-col gap-4">
      <HomeSearchInput
        autoFocus
        value={query}
        onChange={setQuery}
        placeholder={vt(
          "bo.home.shortcuts.searchAction",
          "Rechercher une action (ex. exposition, corbeille…)",
        )}
      />
      {groups.length === 0 ? (
        <p className="text-sm text-slate-500">
          {vt(
            "bo.home.shortcuts.noAction",
            "Aucune action ne correspond à votre recherche.",
          )}
        </p>
      ) : (
        groups.map((group) => (
          <section key={group.id} className="flex flex-col gap-2">
            <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              {group.label}
            </h3>
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              {group.actions.map(({ entry, label, used }) => (
                <PickerRow
                  key={entry.id}
                  icon={entry.icon}
                  label={label}
                  used={used}
                  disabled={full}
                  onSelect={() => onAdd({ id: entry.id })}
                />
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
};
